/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import PageLayout from "examples/LayoutContainers/PageLayout";

function BasicLayout({ image, children }) {
  return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          background: 'linear-gradient(135deg, #0a1628 0%, #1a2942 50%, #0d1f3c 100%)',
          overflow: "hidden",
          "&::before": {
            content: '""',
            position: "absolute",
            top: { xs: 60, md: 100 },
            right: { xs: -40, md: 80 },
            width: { xs: 200, md: 400 },
            height: { xs: 200, md: 400 },
            background: 'rgba(244, 197, 66, 0.08)',
            borderRadius: '50%',
            filter: 'blur(60px)',
            boxShadow: '0 8px 32px 0 rgba(244, 197, 66, 0.15)',
            pointerEvents: "none",
          },
          "@keyframes float": {
            "0%, 100%": { transform: "translateY(0px)" },
            "50%": { transform: "translateY(-20px)" },
          },
        }}
      />
      <MDBox px={1} width="100%" height="100vh" mx="auto" sx={{ position: "relative", zIndex: 1 }}>
        <Grid container spacing={0} height="100%">
          {/* Left Panel - Branding (hidden on mobile) */}
          <Grid 
            item 
            xs={12} 
            md={7} 
            sx={{ 
              display: { xs: 'none', md: 'flex' },
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              px: 4,
            }}
          >
            <MDBox
              sx={{
                textAlign: 'center',
                animation: 'float 6s ease-in-out infinite',
              }}
            >
              <img
                src="/Logo.png"
                alt="STAIL Logo"
                style={{
                  width: '300px',
                  maxWidth: '100%',
                  marginBottom: '32px',
                }}
              />
              <MDTypography
                variant="h2"
                sx={{
                  fontFamily: `'Poppins', sans-serif`,
                  fontWeight: 900,
                  color: '#ffffff',
                  mb: 2,
                  lineHeight: 1.2,
                  letterSpacing: -1,
                  fontSize: { md: '2.5rem', lg: '3rem' },
                  textShadow: '0 4px 20px rgba(0,0,0,0.3)',
                }}
              >
                Sistem Tunggakan Hasil
              </MDTypography>
              <MDTypography
                variant="subtitle1"
                sx={{
                  color: '#f4c542',
                  fontWeight: 600,
                  letterSpacing: 2,
                  fontSize: '1rem',
                }}
              >
                LEMBAGA KEMAJUAN JOHOR TENGGARA
              </MDTypography>
            </MDBox>
          </Grid>

          {/* Right Panel - Form */}
          <Grid 
            item 
            xs={12} 
            md={5}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              px: { xs: 2, sm: 4 },
            }}
          >
            <MDBox sx={{ width: '100%', maxWidth: 450 }}>
              {children}
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </PageLayout>
  );
}

// Set default props for BasicLayout
BasicLayout.defaultProps = {
  image: undefined,
};

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string,
  children: PropTypes.node.isRequired,
};

export default BasicLayout;
